(function () {
  function tierForSize(size) {
    if (size === 1) return 'solo';
    if (size === 6) return 'hexa';
    return 'duo';
  }

  function sizeForValue(value) {
    if (!value) return 1;
    if (value.indexOf('Conform') !== -1) return 6;
    if (value.indexOf('Duo') !== -1) return 2;
    return 1;
  }

  function getSelectedFormatValue(productInfo) {
    var checkedRadio = productInfo.querySelector('input[data-option-name="Format"]:checked');
    if (checkedRadio) return checkedRadio.value;

    var select = productInfo.querySelector('select[name="options[Format]"]');
    if (select) return select.value;

    return null;
  }

  function init(productInfo) {
    var root = productInfo.querySelector('[data-pack-inline]');
    var script = productInfo.querySelector('[data-pack-flavors]');
    if (!root || !script) return;

    var flavors;
    try {
      flavors = JSON.parse(script.textContent);
    } catch (err) {
      return;
    }
    if (!flavors || !flavors.length) return;

    var headingEl = root.querySelector('[data-pack-inline-heading]');
    var stepsEl = root.querySelector('[data-pack-inline-steps]');
    var selections = [];

    function currentSize() {
      return sizeForValue(getSelectedFormatValue(productInfo));
    }

    function placeInCurrentSlot() {
      var value = getSelectedFormatValue(productInfo);
      if (!value) return;
      var slot = productInfo.querySelector('[data-flavor-slot-value="' + value.replace(/"/g, '') + '"]');
      if (slot && slot !== root.parentElement) slot.appendChild(root);
    }

    function render(size) {
      var previous = selections;
      selections = [];
      for (var i = 0; i < size; i++) {
        selections.push(previous[i] !== undefined ? previous[i] : i % flavors.length);
      }

      headingEl.textContent = size === 1 ? 'Choisis ta saveur' : 'Choisis tes ' + size + ' saveurs';

      stepsEl.innerHTML = '';
      for (var index = 0; index < size; index++) {
        stepsEl.appendChild(renderRow(index));
      }
    }

    function renderRow(index) {
      var row = document.createElement('div');
      row.className = 'mph-flavor-row';

      var badge = document.createElement('span');
      badge.className = 'mph-flavor-row__index';
      badge.textContent = '#' + (index + 1);
      row.appendChild(badge);

      var swatch = document.createElement('span');
      swatch.className = 'mph-flavor-row__swatch';
      swatch.textContent = flavors[selections[index]].emoji || '';
      row.appendChild(swatch);

      var select = document.createElement('select');
      select.className = 'mph-flavor-row__select';
      select.setAttribute('aria-label', 'Saveur #' + (index + 1));
      flavors.forEach(function (flavor, flavorIndex) {
        var option = document.createElement('option');
        option.value = flavorIndex;
        option.textContent = flavor.label;
        if (flavorIndex === selections[index]) option.selected = true;
        select.appendChild(option);
      });
      select.addEventListener('change', function (event) {
        // The row lives inside <variant-selects> (it's rendered in the slot for the
        // selected offer). Without this, the native change bubbles into
        // VariantSelects' own listener in global.js, which assumes any <select> it
        // sees is its own swatch dropdown and throws trying to read a
        // `.product-form__input` ancestor that doesn't exist for this control.
        event.stopPropagation();
        selections[index] = parseInt(select.value, 10);
        swatch.textContent = flavors[selections[index]].emoji || '';
      });
      row.appendChild(select);

      return row;
    }

    function resync() {
      placeInCurrentSlot();
      render(currentSize());
      root.hidden = false;
    }

    resync();

    productInfo.addEventListener('change', function (event) {
      if (!event.target.matches('input[data-option-name="Format"], select[name="options[Format]"]')) return;
      root.classList.add('is-updating');
      window.requestAnimationFrame(function () {
        resync();
        window.requestAnimationFrame(function () {
          root.classList.remove('is-updating');
        });
      });
    });

    // product-info.js re-fetches the section on every offer change to sync price/media,
    // then morphs the whole <variant-selects> subtree with the freshly fetched (server-
    // rendered, flavor-picker-less) markup — which wipes out our re-parented picker a
    // moment later, after the request resolves. Re-run the placement once that settles.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        // Inside the quick-add modal, product-info.js's own sectionId getter resolves to
        // dataset.originalSection (quick-add.js rewrites dataset.section to a prefixed,
        // deduped id) — match that same resolution here or this never fires there.
        var sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        resync();
      });
    }

    productInfo.packInline = {
      getItems: function () {
        var size = currentSize();
        var tier = tierForSize(size);
        var packId = 'pack-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);

        return selections.slice(0, size).map(function (flavorIndex, stepIndex) {
          var flavor = flavors[flavorIndex];
          return {
            id: flavor[tier].id,
            quantity: 1,
            properties: {
              _pack_id: packId,
              _pack_size: String(size),
              _pack_box: String(stepIndex + 1),
              _pack_flavor: flavor.label
            }
          };
        });
      }
    };
  }

  document.querySelectorAll('product-info').forEach(init);

  // This script re-executes every time a quick-add modal fetches and injects a fresh
  // <product-info> (Shopify replays its <script> tags on innerHTML injection), which would
  // otherwise stack up duplicate document-level submit listeners — each firing its own
  // /cart/add.js call for a single click. Bind the listener at most once, globally.
  if (window.packInlineComposerSubmitBound) return;
  window.packInlineComposerSubmitBound = true;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('form')) return;

      var productInfo = form.closest('product-info');
      if (!productInfo || !productInfo.packInline) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var submitButton = form.querySelector('[type="submit"]');
      var spinner = form.querySelector('.loading__spinner');
      var errorWrapper = form.querySelector('.product-form__error-message-wrapper');
      var errorMessage = errorWrapper ? errorWrapper.querySelector('.product-form__error-message') : null;

      if (submitButton) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');
      if (errorWrapper) errorWrapper.setAttribute('hidden', 'hidden');

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: productInfo.packInline.getItems() };

      if (cart) {
        body.sections = cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
        body.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }

      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              throw new Error((data && (data.description || data.message)) || 'Erreur lors de l’ajout au panier.');
            }
            return data;
          });
        })
        .then(function (data) {
          if (!cart) {
            window.location.href = window.routes.cart_url;
            return;
          }

          var items = data.items || [data];
          data.key = items[items.length - 1].key;

          // Inside the Boutique quick-add modal, close it first so the cart drawer isn't
          // rendered underneath/behind it — matches product-form.js's own behavior for a
          // normal (non-pack) quick-add submit.
          var quickAddModal = form.closest('quick-add-modal');
          if (quickAddModal) quickAddModal.hide(true);

          cart.renderContents(data);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pack-inline-composer', cartData: data });
          }
        })
        .catch(function (err) {
          if (errorMessage) errorMessage.textContent = err.message || 'Une erreur est survenue. Merci de réessayer.';
          if (errorWrapper) errorWrapper.removeAttribute('hidden');
        })
        .finally(function () {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    },
    true
  );
})();
